"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const map_service_1 = require("../../../../commons/map.service");
const file_manager_service_1 = require("../../../../service/file-manager.service");
const app_service_1 = require("../../../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const router_1 = require("@angular/router");
const http_1 = require("@angular/common/http");
const AppBaseComponent_1 = require("../../../../commons/AppBaseComponent");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
class TermsConditionDialogComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, ar, t, trans, fb, cd, fileManager, dialogRef, snackBar, mapService, data, httpClient, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.trans = trans;
        this.fb = fb;
        this.cd = cd;
        this.fileManager = fileManager;
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.mapService = mapService;
        this.data = data;
        this.httpClient = httpClient;
        this.estimatedPrice = -1;
    }
    init() {
        this.calculatePrice();
    }
    agree() {
        this.dialogRef.close({ currentJob: this.data.currentJob });
    }
    calculatePrice() {
        this.estimatedPrice = -1;
        let tt = this.data.currentJob.jobType.baseTransform;
        this.data.currentJob.quoteTransform(tt).subscribe(amount => {
            this.estimatedPrice = amount.amount;
        });
    }
}
exports.TermsConditionDialogComponent = TermsConditionDialogComponent;
